module.exports = __webpack_public_path__ + "static/media/csrd_report1.2a63ce35.svg";